import React from "react";
import ProfileImg from "../assets/myImage.jpg";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-scroll";
import Animation from "./Animation";

function Profile() {
  return (
    <div name="Home" className="w-full pt-20 md:pt-0 h-screen pb-10 md:pb-0">
      <Animation />
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-content h-full px-4 md:flex-row ">
        <div className="h-full flex flex-col justify-center">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold">
            Software Engineer
          </h2>
          <p className="text-slate-500 py-4 max-w-md">
            I am an IT professional with over 4 years of experience,
            specializing in React Native development. I have expertise in
            building cross-platform mobile applications with intuitive UI/UX,
            collaborating with international clients, and mentoring trainees.
          </p>
          <div>
            <Link
              to="Portfolio"
              smooth
              duration={500}
              className="group bg-gradient-to-r w-fit from-cyan-500 to-blue-500 rounded-md items-center will-change-transform px-6 py-3 my-2 flex text-white cursor-pointer z-1"
            >
              Portfolio
              <span className="group-hover:rotate-90 duration-300">
                <MdOutlineKeyboardArrowRight size={24} className="ml-1" />
              </span>
            </Link>
          </div>
        </div>
        <div className="flex-1">
          <img
            src={ProfileImg}
            className="w-3/5 md:w-1/2 rounded-2xl mx-auto px-2"
            alt="my profile"
          ></img>
        </div>
      </div>
    </div>
  );
}

export default Profile;
